export enum EMeasureCategory {
    NormalRoomUsage = 1,
    FollowingIncident = 2,
    BeforeWork = 3,
    PreliminaryWork = 4,
    DuringWorkOperator = 5,
    DuringWorkEnvironmental = 6,
    EndOfAsbestosWork = 7,
    EndOfMaintenanceWork = 8,
    EndOfAsbestosProcessingWork = 9,
}
